























import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component({
  components: {}
})
class UserInterface3ErrorMessage extends Vue {
  @Prop({ default: false }) showErrorMessageDialog?: boolean
  @Prop({ default: '' }) errorMessage?: string

  emitMessageToCloseDialog () {
    this.$emit('close-dialog', true)
  }
}

export default UserInterface3ErrorMessage

